import { render } from "./foot.vue?vue&type=template&id=4f1be2bc&scoped=true&bindings={}"
import script from "./foot.vue?vue&type=script&lang=js"
export * from "./foot.vue?vue&type=script&lang=js"

import "./foot.vue?vue&type=style&index=0&id=4f1be2bc&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4f1be2bc"

export default script